import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { type User } from '@avanta/shared/types/users';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';

export const useFetchPatients = (search: string): UseQueryResult<User[]> => {
  const enterpriseId = useEnterpriseId();
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_INSURED_USERS, enterpriseId, search],
    queryFn: async () => EnterprisesService.getEmployeesByEnterprise({ enterpriseId, search }),
    select: response => response.data,
    enabled: !!enterpriseId && !!search,
    staleTime: FIFTEEN_MINUTES,
  });
};
